// Core imports
import React from 'react';
import PropTypes from 'prop-types';

// Component imports
import { Col, Modal, Row, Space, Typography } from 'antd';
import { CheckCircleIcon } from '../Icons/CheckCircleIcon';
import { CheckOutlined } from '@ant-design/icons';

// Misc imports
import { t } from 'i18next';

const TranslationResultModal = ({
  isModalOpen = false,
  onClose = () => {},
  importedLanguages = [],
  importedEntities = []
}) => {

  return (
    <Modal
      open={isModalOpen}
      centered
      onCancel={onClose}
      title={null}
      footer={null}
    >
      <Row>
        <Col xs={24} className="text-center">
          <CheckCircleIcon className="text-success fs-xxxxl" />
        </Col>
        <Col xs={24} className="text-center my-3">
          <Typography.Text className="fw-500 fs-xl">
            {t('Translations Imported Successfully!')}
          </Typography.Text>
        </Col>
        <Col xs={24} className="d-flex justify-content-center">
          <Space direction="vertical" className="w-70 ml-3">
            {importedEntities.map(
              entity => <Typography.Text>
                <CheckOutlined className="text-success mr-2"/>
                {entity}
              </Typography.Text>
            )}
          </Space>
        </Col>
        <Col xs={24} className="d-flex justify-content-center my-3">
          <Space direction="vertical" className="w-70 ml-3 fs-lg">
            <Typography.Text>
              {t('has been successfully translated to the following languages:')}
            </Typography.Text>
          </Space>
        </Col>
        <Col xs={24} className="d-flex justify-content-center">
          <Space direction="vertical" className="w-70 ml-3">
            {importedLanguages.map(
              language => <Typography.Text>
                <CheckOutlined className="text-success mr-2"/>
                {language}
              </Typography.Text>
            )}
          </Space>
        </Col>
      </Row>
    </Modal>
  );
};

TranslationResultModal.propTypes = {
  isModalOpen: PropTypes.bool,
  importedLanguages: PropTypes.array,
  importedEntities: PropTypes.array,
  onClose: PropTypes.func
};

export default TranslationResultModal;
